// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__27vPd","title":"ClientReferral_title__3Evu6","itemText":"ClientReferral_itemText__vvSc4"};